import { render, staticRenderFns } from "./MyFeedback.vue?vue&type=template&id=faf53a1c&scoped=true&"
import script from "./MyFeedback.vue?vue&type=script&lang=js&"
export * from "./MyFeedback.vue?vue&type=script&lang=js&"
import style0 from "./MyFeedback.vue?vue&type=style&index=0&id=faf53a1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf53a1c",
  null
  
)

export default component.exports